define('C3.ShoppingExtensions.HeaderMenu.AdditionalLevel.View'
,  [
      'c3_additional_levels.tpl',
      'Profile.Model',
      //'SC.Configuration',
      'Utils',
      'Header.Menu.MyAccount.View',
      'Header.Menu.View',
      'Backbone.View'
   ],
function (
      c3_additional_levels_tpl,
      ProfileModel,
      //Configuration,
      Utils,
      HeaderMenuMyAccountView,
      HeaderMenuView,
      BackboneView
){
   'use strict';
   return Backbone.View.extend({

      template: c3_additional_levels_tpl,

      initialize: function (options) {
         this.options = options;
         console.log(this.options)
         
          //this.render();
      }

      ,  events: {
      'click [data-action="take-to-page"]': 'takeToPage'
   }

   ,  takeToPage: function takeToPage(e){
      console.log(e)
   }

      /*, render: function() 
       {
         this._render();
         //BackboneView.prototype.render.apply(this, arguments);
       }*/

      , getContext: function getContext()
      {
         
           //console.log(column1_values)
           return {
             
           };
      }
   });
});
